"use strict";

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));

var _immer = _interopRequireDefault(require("immer"));

var _lodash = require("lodash");

var _Input = _interopRequireDefault(require("../Input"));

var _MenuPicker = _interopRequireDefault(require("../MenuPicker"));

var _Fields = _interopRequireDefault(require("../editor/Fields"));

var _utils = require("../../utils");

var _theme = require("../../theme");

var _redux = require("../../redux");

var _templateObject, _templateObject2, _templateObject3;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var Menu = function Menu(props) {
  var value = props.value,
      _props$maxLevel = props.maxLevel,
      maxLevel = _props$maxLevel === void 0 ? 3 : _props$maxLevel,
      fields = props.fields,
      onChange = props.onChange;

  var _ref2 = (0, _redux.useAppSelector)(function (state) {
    return state;
  }),
      _ref2$cms$editor = _ref2.cms.editor,
      site = _ref2$cms$editor.site,
      post = _ref2$cms$editor.post,
      siteHasChanged = _ref2$cms$editor.siteHasChanged;

  var _ref3 = (0, _react.useState)([]),
      _ref4 = _slicedToArray(_ref3, 2),
      editing = _ref4[0],
      setEditing = _ref4[1];

  var _ref5 = (0, _react.useState)([]),
      _ref6 = _slicedToArray(_ref5, 2),
      items = _ref6[0],
      setItems = _ref6[1];

  var _ref7 = (0, _react.useState)(false),
      _ref8 = _slicedToArray(_ref7, 2),
      modal = _ref8[0],
      setModal = _ref8[1];

  var translatedMenu = !!(site !== null && site !== void 0 && site.languages) && (post === null || post === void 0 ? void 0 : post.language) && (0, _lodash.isObject)(value);
  (0, _react.useEffect)(function () {
    var menuItems = [];

    if (!!translatedMenu) {
      menuItems = (0, _lodash.get)(value, "".concat(post === null || post === void 0 ? void 0 : post.language)) || [];
    } else {
      menuItems = Array.isArray(value) ? value : [];
    }

    setItems((0, _utils.deepCopyTree)(menuItems));
  }, [value]); // When a post is saved while a menu item is open, we need to manually reset the editing array to allow dragging

  (0, _react.useEffect)(function () {
    !siteHasChanged && setEditing([]);
  }, [siteHasChanged]);

  var handleChange = function handleChange(newValue) {
    if (translatedMenu) {
      onChange(_objectSpread(_objectSpread({}, value), {}, _defineProperty({}, (post === null || post === void 0 ? void 0 : post.language) || '', newValue)));
    } else {
      onChange(newValue);
    }
  }; // Function provided by Ant Design


  var onDrop = function onDrop(info) {
    var dropKey = info.node.props.eventKey;
    var dragKey = info.dragNode.props.eventKey;
    var dropPos = info.node.props.pos.split('-');
    var dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);

    var getLevel = function getLevel() {
      var dropPos = info.node.props.pos.split('-'); // if item is dragged NOT to the top of a node the array will have an additional parameter

      var level = info.dropToGap ? dropPos.length - 1 : dropPos.length;

      var countChildren = function countChildren(node, index) {
        var _node$children;

        var newIndex = index;

        if (node !== null && node !== void 0 && (_node$children = node.children) !== null && _node$children !== void 0 && _node$children.length) {
          newIndex = countChildren(node.children, newIndex + 1);
        }

        return newIndex;
      }; // We have to check if the node has children because they could potentially exceed the max level restriction


      if (info.dragNode.children.length) {
        level = level + countChildren(info.dragNode, 0);
      }

      return level;
    };

    if (getLevel() > Number(maxLevel)) {
      return _antd.message.error({
        content: "Exceeded max depth of ".concat(maxLevel)
      });
    }

    var loop = function loop(data, key, callback) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].key === key) {
          return callback(data[i], i, data);
        }

        if (data[i].children) {
          loop(data[i].children, key, callback);
        }
      }
    };

    var data = _toConsumableArray(items); // Find dragObject


    var dragObj;
    loop(data, dragKey, function (item, index, arr) {
      arr.splice(index, 1);
      dragObj = item;
    });

    if (!info.dropToGap) {
      // Drop on the content
      loop(data, dropKey, function (item) {
        item.children = item.children || []; // where to insert

        if (dropPosition === 0) {
          item.children.unshift(dragObj);
        } else {
          item.children.push(dragObj);
        }
      });
    } else if ((info.node.props.children || []).length > 0 && // Has children
    info.node.props.expanded && // Is expanded
    dropPosition === 1 // On the bottom gap
    ) {
      loop(data, dropKey, function (item) {
        item.children = item.children || []; // where to insert

        item.children.unshift(dragObj);
      });
    } else {
      var ar = [];
      var i = 0;
      loop(data, dropKey, function (item, index, arr) {
        ar = arr;
        i = index;
      });

      if (dropPosition === -1) {
        ar.splice(i, 0, dragObj);
      } else {
        ar.splice(i + 1, 0, dragObj);
      }
    }

    handleChange(data);
  };

  var handleRemove = function handleRemove(key) {
    var newItems = (0, _utils.removeFromTree)({
      children: _toConsumableArray(items)
    }, key);
    handleChange(newItems.children); // Remove key from array

    var nextValue = (0, _immer.default)(editing, function (draft) {
      if (draft.includes(key)) {
        draft = draft.filter(function (k) {
          return k !== key;
        });
      }

      return draft;
    });
    setEditing(nextValue);
  };

  var handleAdd = function handleAdd(item) {
    var nextValue = (0, _immer.default)(items, function (draft) {
      draft.push(item);
      return draft;
    });
    handleChange(nextValue);
  };

  var handleToggleCollapse = function handleToggleCollapse(key) {
    var nextValue = (0, _immer.default)(editing, function (draft) {
      if (draft.includes(key)) {
        draft = draft.filter(function (k) {
          return k !== key;
        });
      } else {
        draft.push(key);
      }

      return draft;
    });
    setEditing(nextValue);
  };

  var handleUpdate = function handleUpdate(value, name, key) {
    var updateItem = function updateItem(parentNode, child, params) {
      if (child.key === params.key) {
        return (0, _immer.default)(child, function (draft) {
          (0, _lodash.set)(draft, name, params.value);
        });
      } else {
        return child;
      }
    };

    var newItems = (0, _utils.recursivelyUpdateTree)({
      children: items
    }, updateItem, {
      key: key,
      value: value
    });
    handleChange(newItems);
  };

  var renderFields = function renderFields(key) {
    if (!fields) {
      return null;
    }

    var formattedFields = fields.map(function (field) {
      var _searchTree, _searchTree$value;

      return _objectSpread(_objectSpread({}, field), {}, {
        value: (_searchTree = (0, _utils.searchTree)(items, key)) === null || _searchTree === void 0 ? void 0 : (_searchTree$value = _searchTree.value) === null || _searchTree$value === void 0 ? void 0 : _searchTree$value[field.id]
      });
    });
    return /*#__PURE__*/_react.default.createElement(_Fields.default, {
      fields: formattedFields,
      onChangeElement: function onChangeElement(field) {
        return handleUpdate(field.value, "value.".concat(field.id), key);
      },
      padding: false
    });
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_antd.Tree, {
    className: "draggable-tree",
    draggable: editing.length === 0,
    showLine: true,
    blockNode: true,
    onDrop: onDrop,
    treeData: items,
    titleRender: function titleRender(node) {
      return /*#__PURE__*/_react.default.createElement(_antd.Collapse, {
        ghost: true,
        onChange: function onChange() {
          return handleToggleCollapse(node.key);
        }
      }, /*#__PURE__*/_react.default.createElement(_antd.Collapse.Panel, {
        key: "menu",
        header: /*#__PURE__*/_react.default.createElement("span", {
          style: {
            cursor: editing.length === 0 ? 'grab' : 'not-allowed'
          }
        }, (0, _htmlReactParser.default)(node.title || ' ')),
        showArrow: false
      }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
        direction: "vertical"
      }, /*#__PURE__*/_react.default.createElement(_Input.default, {
        label: "title",
        value: node.title,
        onChange: function onChange(e) {
          return handleUpdate(e.target.value, 'title', node.key);
        }
      }), /*#__PURE__*/_react.default.createElement(_Input.default, {
        label: "Url",
        value: node.url,
        onChange: function onChange(e) {
          return handleUpdate(e.target.value, 'url', node.key);
        },
        disabled: node.postTypeID
      }), renderFields(node.key), /*#__PURE__*/_react.default.createElement(_antd.Button, {
        size: "small",
        danger: true,
        children: "Remove",
        onClick: function onClick() {
          return handleRemove(node.key);
        },
        disabled: node.children.length > 0
      }))));
    }
  })), /*#__PURE__*/_react.default.createElement(AddButton, {
    items: items && items.length > 0,
    onClick: function onClick() {
      return setModal(true);
    }
  }, /*#__PURE__*/_react.default.createElement(_icons.PlusOutlined, null)))), /*#__PURE__*/_react.default.createElement(_antd.Modal, {
    title: 'Menu Items',
    visible: modal,
    onCancel: function onCancel() {
      return setModal(false);
    },
    width: 600,
    footer: null
  }, /*#__PURE__*/_react.default.createElement(_MenuPicker.default, {
    onAdd: handleAdd
  })));
};

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  && {\n    overflow: auto;\n\n    .ant-tree {\n      background-color: transparent;\n    }\n\n    .ant-tree-list-holder {\n      padding-top: 6px;\n    }\n\n    .ant-collapse {\n      background-color: transparent;\n      border: none !important;\n    }\n\n    .ant-collapse-header {\n      padding: 5px !important;\n    }\n\n    .ant-tree-switcher-line-icon {\n      transform: translateY(3px);\n    }\n\n    .ant-tree-node-content-wrapper {\n      padding: 0;\n\n      &:hover {\n        background-color: transparent;\n      }\n    }\n    .ant-tree-node-content-wrapper.ant-tree-node-selected {\n      background-color: transparent;\n    }\n\n    .ant-collapse-content-box {\n      padding-top: 0 !important;\n    }\n\n    .ant-collapse-content > .ant-collapse-content-box {\n      border-bottom: none;\n      background: transparent;\n    }\n\n    .rst__rowContents {\n      min-width: 150px;\n    }\n  }\n"])));

var AddButton = (0, _styledComponents.default)('div')(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 46px;\n  width: 100%;\n  border: 1px solid transparent;\n  cursor: pointer;\n  transition: ease-in all 0.2s;\n\n  &:hover {\n    border-color: ", ";\n  }\n\n  ", "\n"])), _theme.colors.tertiary, function (_ref) {
  var items = _ref.items;
  return !items && (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n      border-color: ", ";\n\n      &:hover {\n        border-color: #c9cfdb;\n      }\n    "])), _theme.colors.tertiary);
});
var _default = Menu;
exports.default = _default;